import styled from 'styled-components'
import { AspectRatioGrid } from '@sketch/components'

export const AspectRatioGridWrapper = styled(AspectRatioGrid)`
  flex-grow: 1;
  align-content: flex-start;
`
